


































































































import { apiUrl } from "@/domain";
import Vue from "vue";
import VueUploadComponent from "vue-upload-component";
import ApiService from "../../services/ApiService";
import ImageCompressor from "compressorjs";

export default Vue.extend({
  data() {
    return {
      form: {
        type: {},
      },
      council_logo: [],
      council_id: null,
      loading: false,
      edit: false,
      cropper: false,
      uploadUrl:
        apiUrl +
        "/api/uploadFile?notice&school_id=" +
        this.$route.params.council_id,
      rules: {
        name: [
          {
            required: true,
            message: "Please input Local Authority Name",
            trigger: "change",
          },
          {
            min: 3,
            message: "Length should be at least 3",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "Please enter a password",
            trigger: "change",
          },
          {
            min: 6,
            message: "Please enter at least 6 characters",
            trigger: "change",
          },
        ],
        email: [
          {
            type: "email",
            required: true,
            message: "Please enter user email",
            trigger: "change",
          },
        ],
        first_name: [
          {
            required: true,
            message: "Please enter first name",
            trigger: "change",
          },
        ],
        last_name: [
          {
            required: true,
            message: "Please enter last name",
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: "Please enter phone",
            trigger: "change",
          },
        ],
        main_phone: [
          {
            min: 8,
            required: true,
            message: "Please enter valid number",
            trigger: "blur",
          },
        ],
        support_email: [
          {
            required: true,
            message: "Please enter valid email",
            trigger: "change",
          },
        ],
      },
    };
  },
  components: {
    "file-upload": VueUploadComponent,
  },
  methods: {
    inputFile: function (newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        if (newFile.type.substr(0, 6) === "image/") {
          if (!this.$refs.upload.active) {
            this.imagesLoading = false;
          }
          const response = newFile.xhr.response;
          this.form.council_logo = response;
        }
      }
      // Automatic upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (newFile.error == "") {
          this.imagesLoading = true;
          if (!this.$refs.upload.active) {
            new ImageCompressor(newFile.file, {
              quality: 0.9,
              maxHeight: 1200,
              success: (result) => {
                // Successfully deleted the error to write the new file
                this.$refs.upload.update(newFile, {
                  file: result,
                  error: "",
                  size: result.size,
                  type: result.type,
                });
                setTimeout(() => {
                  this.$refs.upload.active = true;
                }, 200);
              },
            });
          }
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.alert("Your choice is not a picture");
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = "";
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },
    saveCouncil() {
      this.$refs["councilform"].validate((valid) => {
        if (valid) {
          ApiService.generalApi.saveCouncilAsAdmin(this.form).then((resp) => {
            if (resp.data.id) {
              this.council_id = resp.data.id;
              this.$notify.success({
                title: "Success",
                message: "Saved",
              });
            } else {
              alert("Errors");
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    goToCouncils() {
      this.$router.push("councils");
    },
  },
  computed: {
    token: function () {
      return "Bearer " + this.$store.state.token;
    },
    accType: function () {
      return this.$store.state.user.admin_type.name;
    },
  },
  mounted() {
    const councilId = this.$route.params.council_id;
    if (!isNaN(councilId)) {
      ApiService.sadminApi.getCouncil(councilId).then((resp) => {
        this.form = resp.data;
        this.form.first_name = resp.data.admins[0].first_name;
        this.form.last_name = resp.data.admins[0].last_name;
        this.form.phone = resp.data.admins[0].phone;
        this.form.email = resp.data.admins[0].email;
        this.form.school_phone = resp.data.phone;
        this.form.support_email = resp.data.email;
        this.council_id = councilId;
        this.council_logo = [{ url: resp.data.logo_url }];
        this.rules.password[0].required = false;
      });
    }
  },
});
